<template lang="pug">
  div.item-sign-in-with-email
    //- div(v-if="status == 'start'").sign-in-btn.cursor-pointer.rounded.pl16.pr18.py10.f.fm
      v-icon(size="28px" color="#fff").mr10 mdi-email
      span(@click="onStartSignIn").bold {{($route.name == 'sign-in') ? 'Sign in with Email' : 'Sign up with Email' }}
    div(v-if="status == 'ask_email'").ask-email
      v-text-field(v-if="$route.name == 'sign-up'"
        v-model="name" label="Name"
        :color="pallete.$active_color"
        outlined)
      v-text-field(v-model="email" label="Email"
        :color="pallete.$active_color"
        :rules="rulesEmail" outlined)
      v-text-field(v-model="password" label="Password"
        outlined
        :rules="form.rules"
        :counter="!noValidation"
        :hint="form.hint"
        :append-icon="togglePwIcon.icon"
        :type="togglePwIcon.type"
        :color="pallete.$active_color"
        autocomplete="on"
        @click:append="showPwIcon = !showPwIcon")
      div.f.fm.flex-right.mt12
        //- span(@click="onCancel").cancel.mr16 Cancel
        v-btn(:color="pallete.$active_color"
          @click="signInWithEmail"
          dark) {{(this.$route.name == 'sign-in') ? 'Sign in' : 'Sign up'}}
    div(v-if="status == 'check_validation'").check-validation
      span.block We have sent email for validation.
      span.block Please check {{email}}.
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.item-sign-in-with-email {
  .sign-in-btn {
    background: $active_color;
    width: 228px;
    span {
      color: #fff;
    }
  }
  .ask-email {
    width: 280px;
    .cancel {
      color: $secondary_text_color;
    }
  }
  .check-validation {
    width: 280px;
  }
}
</style>

<script>
import database from '@/database'
import { firebase, auth } from '@/components/utils/firebase'
import { domain } from '@/components/utils/config'
import { Capacitor } from '@capacitor/core'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('auth')

export default {
  data () {
    return {
      status: 'ask_email',
      name: '',
      email: '',
      password: '',
      rulesEmail: [
        v => !!v || '',
        v => /.+@.+\..+/.test(v) || ''
      ],
      showPwIcon: false,
      noValidation: true,
      enableSignIn: false
    }
  },
  // props: {
  //   data: {
  //     type: Object,
  //     required: true
  //   }
  // },
  computed: {
    form () {
      const min = '8 or more characters'
      const msg = `${min}`
      const required = v => !!v || ''
      const format = v => /^[\w-]{8,72}$/.test(v) || msg

      const rules = this.noValidation ? [required] : [format]
      const hint = this.noValidation ? undefined : msg
      const placeholder = this.noValidation ? undefined : min
      return { rules, hint, placeholder }
    },
    togglePwIcon () {
      const icon = this.showPwIcon ? 'mdi-eye' : 'mdi-eye-off'
      const type = this.showPwIcon ? 'text' : 'password'
      return { icon, type }
    }
  },
  watch: {
    name () {
      this.formValidation()
    },
    email () {
      this.formValidation()
    },
    password () {
      this.noValidation = (this.password === '') ? true : false
      this.formValidation()
    },
    '$route': function (to) {
      this.formValidation()
    }
  },
  async created () {
    firebase.auth().getRedirectResult().then(async (result) => {
      console.log('result', result)
      if (result.providerId == 'password') {
        console.log('result2', result)
      }
      // if (result.credential) {
      //   this.setUnderLoading(true)
      //   if (result.credential.signInMethod === 'facebook.com') {
      //     // This gives you a Facebook Access Token. You can use it to access the Facebook API.
      //     const token = result.credential.accessToken
      //     this.signUp(token)
      //   }
      // }
    })
  },
  methods: {
    ...mapActions(['setUnderLoading']),
    async signInWithEmail () {
      if (!this.enableSignIn) return

      this.setUnderLoading(true)
      const providers = await auth.fetchSignInMethodsForEmail(this.email)
      console.log('providers', providers)

      if (providers[0] && this.$route.name == 'sign-up') {
        alert('You have account. Please sign in.')
        // this.pushPage('sign-in')
        this.$router.push('sign-in')
        this.setUnderLoading(false)
        return
      }
      // アカウントがないか、emailでログインしたことがあれば処理する
      let res
      if (!providers[0] || providers.findIndex(p => p === firebase.auth.EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD) !== -1) {
        if (!providers[0]) { // sign up
          await auth.createUserWithEmailAndPassword(this.email, this.password)
          res = await auth
            .signInWithEmailAndPassword(this.email, this.password)
            .catch(function(error) {
              error.status = 'error'
              return error
            })
          if (res.status === 'error') {
            alert(res.message)
            this.setUnderLoading(false)
            return
          }

          const random0to10 = () => Math.floor(Math.random() * 100)
          const userObj = {
            uid: res.user.uid,
            name: this.name,
            pos: { x: random0to10(), y: random0to10() },
            createdAt: new Date(),
            updatedAt: new Date()
          }
          await database.userCollection().signUp(userObj)

          const pathWithSignUp = (this.$route.params.redirectPath) ? 
            `/tutorial/${encodeURIComponent(this.$route.params.redirectPath)}` : '/tutorial'

          this.$router.push('/home')
          await this.sleep(400)
          this.$router.push(pathWithSignUp)
          
          return
        } else { // sign in
          res = await auth
            .signInWithEmailAndPassword(this.email, this.password)
            .catch(function(error) {
              error.status = 'error'
              return error
            })
          if (res.status === 'error') {
            alert(res.message)
            this.setUnderLoading(false)
            return
          }
        }

        if (this.$route.params.redirectPath) {
          const path = decodeURIComponent(this.$route.params.redirectPath)
          this.$router.push('/home')
          await this.sleep(400)
          this.$router.push(path)
        } else {
          this.$router.push('/home')
        }

        // メール受信を行う場合
        // if (res.user.emailVerified) {
        //   console.log('Email has been verified')
        //   const path = (this.$route.params.redirectPath) ? 
        //     decodeURIComponent(this.$route.params.redirectPath)
        //     : '/home'
        //   this.pushPage(path)
        // } else {
        //   console.log('Email is not verified')
        //   let actionCodeSettings
        //   if (!Capacitor.isNative) {
        //     actionCodeSettings = {
        //       // URL you want to redirect back to. The domain (www.example.com) for this
        //       // URL must be in the authorized domains list in the Firebase Console.
        //       url: `${domain}/finish-email-validation`,
        //       handleCodeInApp: false
        //       // for native settings
        //       // handleCodeInApp: true,
        //       // iOS: {
        //       //   bundleId: 'capacitor.ionic.vue'
        //       // },
        //       // android: {
        //       //   packageName: 'capacitor.ionic.vue',
        //       //   installApp: true,
        //       //   minimumVersion: '12'
        //       // }
        //       // dynamicLinkDomain: 'example.page.link'
        //     }
        //   }
        //   console.log('actionCodeSettings', actionCodeSettings)
        //   res.user.sendEmailVerification(actionCodeSettings)
        //   this.status = 'check_validation'
        // }
      } else {
        alert('This address has been registered.')
        return
      }
      this.setUnderLoading(false)
    },
    formValidation () {
      if (this.$route.name === 'sign-in') {
        if (!this.email || !this.password) {
          this.enableSignIn = false
        } else {
          this.enableSignIn = true
        }
      } else if (this.$route.name === 'sign-up') {
        if (!this.name || !this.email || !this.password) {
          this.enableSignIn = false
        } else {
          this.enableSignIn = true
        }
      }
    },
    onStartSignIn () {
      this.$emit('toggleShowSocialSignIn')
      this.status = 'ask_email'
    },
    onCancel () {
      this.$emit('toggleShowSocialSignIn')
      this.status = 'start'
    }
  }
}
</script>